import styles from "./LobbyTile.module.scss";
import {useNavigate} from "react-router-dom";
import {connectToLobby} from "../../../../api/lobby";
import {useState} from "react";
import {LobbyTileProps} from "../../../types/props";
import {LobbyState} from "../../../types/lobby";
import {getCurrentUserId} from "../../../../api/authContext";

const LobbyTile = ({lobby}: LobbyTileProps) => {
    const navigate = useNavigate();

    const [isModalOpen, setModalOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    let youInLobby = lobby.users.some(user => user.userId === getCurrentUserId());

    const isLobbyAvailable = youInLobby
        || (lobby.state === LobbyState.WAITING && lobby.users.length < lobby.capacity);

    const onTileClick = () => {
        if (!isLobbyAvailable || !lobby.id) {
            return;
        }

        setError(null);
        setPassword("");
        setModalOpen(true);
    };

    const closeModal = () => {
        if (isSubmitting) {
            return;
        }
        setModalOpen(false);
        setPassword("");
        setError(null);
    };

    const onConnect = () => {
        if (!lobby.id || !password.trim()) {
            return;
        }

        setIsSubmitting(true);
        setError(null);

        connectToLobby(lobby.id, password)
            .then(() => navigate(`/lobby/${lobby.id}`))
            .catch(() => {
                setError("Wrong password or lobby is not available.");
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <>
            <div
                className={`${styles.lobbyTile} ${
                    isLobbyAvailable
                        ? styles["lobbyTile__available"]
                        : styles["lobbyTile__notAvailable"]
                }`}
                onClick={onTileClick}
            >
                <div className={styles["lobbyTile__titleBlock"]}>
                    <span className={styles["lobbyTile__title"]}>{lobby.title}</span>
                    {youInLobby && (<span className={styles.lobbyTile__youTag}>You</span>)}
                </div>
                <span className={styles["lobbyTile__players"]}>
                    Players: {lobby.users?.length ?? 0} / {lobby.capacity}
                </span>
            </div>

            {isModalOpen && (
                <div className={styles.modalBackdrop}>
                    <div className={styles.modal}>
                        <h3 className={styles.modalTitle}>Join lobby: {lobby.title}</h3>

                        <label className={styles.modalLabel}>
                            Password:
                            <input
                                type="password"
                                className={styles.modalInput}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                disabled={isSubmitting}
                                placeholder="Lobby password"
                            />
                        </label>

                        {error && <div className={styles.modalError}>{error}</div>}

                        <div className={styles.modalButtons}>
                            <button
                                className={styles.modalBtnPrimary}
                                onClick={onConnect}
                                disabled={isSubmitting || !password.trim()}
                            >
                                {isSubmitting ? "Connecting..." : "Connect"}
                            </button>
                            <button
                                className={styles.modalBtnSecondary}
                                onClick={closeModal}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LobbyTile;
